import React, { useEffect } from 'react'
import { Slot } from 'expo-router'
import { useStore } from '@/router/(root)/daily10/d10Module' 

export default function D10Layout() {

  const setPlayedDate = useStore(s => s.setPlayedDate)
  const setError = useStore(s => s.setError)
  const setIsStartingGame  = useStore(s => s.setIsStartingGame )

  useEffect(() => {
    setPlayedDate()
    setError(null)
    setIsStartingGame(false)
  }, [])

  return (
    <Slot />
  )
}
